import Admin from "../Admin";
import React from "react";
import CardAdminQueueList from "../../../Component/Card/Admin/Queue/CardAdminQueueList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminQueueList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminQueueList />
        );
    }

    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/queue"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Queues" buttons={buttons} />
        );
    }
}
